module.exports = __webpack_public_path__ + "static/media/broadcast.abf1bd91.svg";


//////////////////
// WEBPACK FOOTER
// ./src/icons/broadcast.svg
// module id = 242
// module chunks = 0